/**
 * Synonym dictionary for FAQ search
 *
 * This file contains mappings of terms to their synonyms.
 * Each key in the dictionary is a term, and its value is an array of synonyms.
 * When a user searches for a term, the search will also include its synonyms.
 */

// Dictionary mapping terms to their synonyms
export const synonymDict: Record<string, string[]> = {
  "오류": ["버그", "에러", "문제"],
  "버그": ["오류", "에러", "문제"],
  "에러": ["오류", "버그", "문제"],
  "문제": ["오류", "버그", "에러"],

  "회원": ["유저", "사용자", "멤버"],
  "유저": ["회원", "사용자", "멤버"],
  "사용자": ["회원", "유저", "멤버"],
  "멤버": ["회원", "유저", "사용자"],

  "비밀번호": ["패스워드", "암호"],
  "패스워드": ["비밀번호", "암호"],
  "암호": ["비밀번호", "패스워드"],

  "데이터": ["정보", "기록"],
  "정보": ["데이터", "기록"],
  "기록": ["데이터", "정보"],

  "설정": ["세팅", "환경설정"],
  "세팅": ["설정", "환경설정"],
  "환경설정": ["설정", "세팅"],

  "결제": ["지불", "구매"],
  "지불": ["결제", "구매"],
  "구매": ["결제", "지불"],

  "답장": ["답변"],
  "답변": ["답장"],

  "만료": ["종료", "종결"],
  "종료": ["만료", "종결"],
  "종결": ["만료", "종료"],

  "정지": ["중지", "홀드", "일시정지", "일시중지"],
  "중지": ["정지", "홀드", "일시정지", "일시중지"],
  "홀드": ["중지", "정지", "일시정지", "일시중지"],
  "일시정지": ["중지", "정지", "홀드", "일시중지"],
  "일시중지": ["정지", "중지", "홀드", "일시정지"],

};

/**
 * Get all synonyms for a given term
 * @param term The term to get synonyms for
 * @returns Array of synonyms including the original term
 */
export function getSynonyms(term: string): string[] {
  // If the term exists in the dictionary, return its synonyms
  if (term in synonymDict) {
    return [term, ...synonymDict[term]];
  }

  // If the term doesn't exist in the dictionary, return just the term
  return [term];
}

/**
 * Expand a search query with synonyms
 * @param query The search query
 * @returns The expanded query with synonyms
 */
export function expandQueryWithSynonyms(query: string): string[] {
  if (!query) return [];

  // Split the query into words
  const words = query.trim().split(/\s+/);

  // For each word, get its synonyms
  const expandedWords = words.map(word => getSynonyms(word));

  // Create all possible combinations of expanded words
  // For simplicity, we'll just return all expanded words as separate queries
  return expandedWords.flat();
}